export const handleFirebaseAuthError = (error, t = (x) => x) => {
  const errorCode = error?.code;

  switch (errorCode) {
    case "auth/account-exists-with-different-credential":
      return t("account_exists_with_different_credential");
    case "auth/quota-exceeded":
      return t("quota_exceeded");
    case "auth/invalid-email":
      return t("invalid_email");
    case "auth/user-disabled":
      return t("user_disabled");
    case "auth/user-not-found":
      return t("user_not_found");
    case "auth/email-already-in-use":
      return t("email_already_in_use");
    case "auth/operation-not-allowed":
      return t("operation_not_allowed");
    case "auth/too-many-requests":
      return t("too_many_attempts");
    case "auth/network-request-failed":
      return t("network_error");
    case "auth/internal-error":
      return t("internal_error");
    case "auth/expired-action-code":
      return t("expired_link");
    case "auth/invalid-action-code":
      return t("invalid_link");
    case "auth/missing-email":
      return t("missing_email");
    case "auth/invalid-credential":
      return t("invalid_credential");
    case "auth/argument-error":
      return t("argument_error");
    case "auth/invalid-verification-code":
      return t("invalid_verification_code");
    case "auth/invalid-verification-id":
      return t("invalid_verification_id");
    default:
      return error?.message || t("unknown_error");
  }
};
